import React from 'react';
import { type OfficialMenuGroup } from '@/apiSdk/api.type';
import ClientHeader from './ClientHeader';
import ServerHeader, { type OverseaOfficialHeaderAppearance } from './ServerHeader';

interface HeaderProps {
  /** 显式选择是否跳过 ClientHeader 包装，不用于自动判断当前运行环境。 */
  isSSR?: boolean;
  showAlert?: boolean;
  appearance?: OverseaOfficialHeaderAppearance;
  menus: OfficialMenuGroup[];
}

/**
 * 官网导航入口：完整传递接口分组，由 ServerHeader 统一渲染标题和子菜单。
 * isSSR 为 true 时直接渲染 ServerHeader；默认通过 ClientHeader 补充登录、下载和滚动状态。
 */
export default function Header({
  showAlert, isSSR = false, menus, appearance,
}: HeaderProps) {
  // 调用方显式指定时，跳过登录、下载和滚动状态包装。
  if (isSSR) {
    return <ServerHeader showAlert={showAlert} menus={menus} appearance={appearance} />;
  }

  // 默认包装也参与 SSR；挂载后更新状态，菜单展开交互仍由 ServerHeader 负责。
  return <ClientHeader showAlert={showAlert} menus={menus} appearance={appearance} />;
}

export { ServerHeader, ClientHeader };
export type { OverseaOfficialHeaderAppearance };
